module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Heavy.d8ad1852.ttf";